import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useExchangePortalAxios from "../utils/axios";
import { resetResponseState } from "../features/responseSlice";

const useLogout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const ExchangePortalClient = useExchangePortalAxios();

    const logout = async () => {
        try {
            await ExchangePortalClient.post('/Authentication/Logout', {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-SESSION-ID': sessionStorage.getItem("SessionID"),
                    'Authorization': `Bearer ${sessionStorage.getItem("Token")}`, 
                },
                withCredentials: true,
            });
        } catch (error) {
            console.error('Logout failed:', error);
        } finally {
            sessionStorage.removeItem("Token");
            sessionStorage.removeItem("SessionID");
            sessionStorage.removeItem("UserName");
            sessionStorage.removeItem("Role");
            sessionStorage.removeItem("Features");
            sessionStorage.removeItem("EntityID");
            sessionStorage.removeItem("LegalEntityID");
            sessionStorage.removeItem("Merchants");
            sessionStorage.removeItem("Entities");

            dispatch(resetResponseState());

            navigate("/", { replace: true });
        }
    };

    return {
        logout,
    }
}

export default useLogout;
